import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { Col, Form, Row } from "react-bootstrap";
import {
  CustomInput,
  InputLayout,
  SubmitButton,
} from "../components/shared/input";
import dynamic from "next/dynamic";
import FormSubmit from "../components/shared/submit";
import { initAuth } from "../utils/state";

const Authentication = dynamic(() =>
  import("../components/Layouts/Authentication")
);

const Signin = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const HandleSubmit = async (data) => {
    if (data.role === "Buyer") {
      initAuth(dispatch);
      router.push(router.query.redirecturl || "/");
    } else router.push("https://members.dealsonopenbox.com");
  };

  return (
    <Authentication title="SignIn">
      <FormSubmit url="/login" callback={HandleSubmit}>
        <h1 className=" fs-4 fw-bold text-center">Sign In</h1>
        <p className="text-center mb-4 font-e-lg">
          Enhance Your Shopping Experience With Us
        </p>
        <InputLayout className="overflow-hidden">
          <CustomInput
            name="username"
            placeholder="UserName Or Email"
            indicator={false}
          />
          <CustomInput
            name="password"
            type="password"
            placeholder="Password"
            indicator={false}
          />
        </InputLayout>
        <Row className="justify-content-between mt-3 px-2">
          <Col sm="auto">
            <Link href="/signup">
              <a href="/signup" className="font-md text-info fw-bold">
                Register
              </a>
            </Link>
          </Col>
          <Col sm="auto">
            <Link href="/forgot">
              <a href="/forgot" className="font-md text-primary fw-bold">
                Forgot Password
              </a>
            </Link>
          </Col>
        </Row>
        <SubmitButton title="SignIn" variant="dark rounded-8 my-4 py-2" />
      </FormSubmit>
    </Authentication>
  );
};

export default Signin;
